import SeeMore from 'ui/modules/Pagination/SeeMore';
import React, { useState } from 'react';
import { PaginatedResult } from 'types';
import { PaginationOptions } from 'types/api';
import { ICwUserId, UserProfile } from 'types/user';
import Avatar from 'ui/elements/avatars/Avatar';
import InfoCard from 'ui/views/cards/InfoCard';
import styled from '@emotion/styled';
import { halfSpacing } from 'ui/theme/themeConstants';

const UserProfileDialog = React.lazy(() => import('domain/users/UserProfile/UserProfileDialog'));

interface Props {
  emptyMessage?: string;
  resource: PaginatedResult<ICwUserId>;
  userProfiles: UserProfile[];
  seeMore: (paginationOptions: PaginationOptions) => Promise<void>;
}

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${halfSpacing};
`;

export default function UserList(props: Props) {
  const emptyMessage = props.emptyMessage || 'Nothing here';
  const [selectedUserId, setSelectedUserId] = useState<string | null>(null);

  return (
    <>
      <List>
        {props.resource.values.length === 0 ? (
          <div className="u-padding-content-x">
            <InfoCard>{emptyMessage}</InfoCard>
          </div>
        ) : (
          props.resource.values.map(value => {
            const user = props.userProfiles.find(user => user.cwUserId === value.cwUserId);
            return user ? (
              <button
                key={user.cwUserId}
                onClick={() => setSelectedUserId(user.cwUserId)}
                className="u-flex u-flex-align-center"
                style={{ width: '100%', textAlign: 'left', cursor: 'pointer' }}
              >
                <Avatar className="u-half-spacing-right" imageUrl={user.imageUrl} />
                {user.name}
              </button>
            ) : null;
          })
        )}
        <SeeMore className="u-content-spacing-top" loadResource={props.seeMore} resource={props.resource} />
      </List>
      {selectedUserId && <UserProfileDialog cwUserId={selectedUserId} onClose={() => setSelectedUserId(null)} />}
    </>
  );
}
